export const autoplayState = {
    defaultState: {
        autoplayEnabled: navigator.userActivation.hasBeenActive,
    },
    actions: {
        enableAutoplay: (_, state) => ({...state, autoplayEnabled: true}),
    },
}
